import { useState } from "react";

import { CampaignToolDetails } from "../mock/campaingsDataMock";

import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import 'react-toastify/dist/ReactToastify.css';
import { environment } from "../environment";
import { CampaignFieldsEnum, CampaignScopeDisplayName, CampaignStateEnum, ImageTypeMethodEnum } from "../models/campaign.model";
import { CampaignTableModel } from "../models/tables.model";
import { DASHBOARD_ROUTES } from "../router/RoutesEnum";
import { ShowFailedHeroToastMessage, ShowFailedVoucherToastMessage, ShowSuccessHeroToastMessage, ShowSuccessVoucherToastMessage } from "../shared/Notifications/Toasters";
import { CampaignTable } from "../shared/Tables/CampaignTable";
import { CurrencyUtil } from "../utils/currency.util";
import { DateUtil } from "../utils/date.util";
import { useAxios } from "./useAxios";
import { useUserContext } from "../context/user.context";

export const useCampaign = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { keycloak, initialized } = useKeycloak();
  const kcToken = keycloak?.token || ''

  const { axiosInstance } = useAxios();

  const { merchantId, merchantInfo } = useUserContext();

  const [startDate, setStartDate] = useState(DateUtil.firstDayOfCurrentMonth)
  const [endDate, setEndDate] = useState(new Date())

  /*const config = {
    headers: {
      'content-type': 'multipart/form-data',      
      Authorization: initialized ? `Bearer ${kcToken}` : undefined,
    }
  }*/
  const { axiosInstance: axiosInstanceMultipart } = useAxios(null);

  const [totalNumberOfCampaigns, setTotalNumberOfCampaigns] = useState(0);
  const [totalNumberOfRunning, setTotalNumberOfRunning] = useState(0);
  const [totalNumberOfPaused, setTotalNumberOfPaused] = useState(0);
  const [totalNumberOfCanceled, setTotalNumberOfCanceled] = useState(0);

  const [campaignActiveTableData, setCampaignActiveTableData] = useState([]);
  const [campaignToolTableData, setCampaignToolTableData] = useState([]);

  const [activeCampaigns, setActiveCampaigns] = useState([]);
  const [loadingFlag, setLoadingFlag] = useState(false)


  const filteredActiveTable = (data, selectedStatus) => {
    const filteredData = data.filter((activeData) => {
      const campaignState = (selectedStatus || []).map((activeData) => activeData.value);
      const state = !selectedStatus.length || campaignState.includes(activeData.state);
      return state;
    });
    return filteredData;
  };

  const calculateCampaignsData = (campaignReponseData) => {

    //UPDATE AND RECALCULATE THE TABLE
    const tableDataActiveCampaign = campaignReponseData.map((data) => {

      const scopeNames = data[CampaignFieldsEnum.scopes]?.map(val => CampaignScopeDisplayName(val?.name.toUpperCase())).join(", ")

      return {

        [CampaignTableModel.Id]: data?.id,
        [CampaignTableModel.CampaignName]: data?.name,
        [CampaignTableModel.ValidFrom]: data?.startDate && DateUtil.formatDateFromBackend(data?.startDate),
        [CampaignTableModel.ValidTo]: data?.endDate && DateUtil.formatDateFromBackend(data?.endDate),
        [CampaignTableModel.Scope]: scopeNames,
        [CampaignTableModel.IssuedVouchers]: data?.issuedVouchers || 0, //data[CampaignFieldsEnum.issuedVouchers],
        [CampaignTableModel.RedeemedVouchers]: data?.redeemedVouchers || 0, //data[CampaignFieldsEnum.redeemedVouchers],
        [CampaignTableModel.State]: data?.state || CampaignStateEnum.DRAFT
      };
    });

    //REMOVE DRAFT/EDITABLE CAMPAIGNS FROM ACTIVE CANPAIGNS TABLE
    setCampaignActiveTableData(tableDataActiveCampaign.filter(campaign => campaign[CampaignTableModel.State] !== CampaignStateEnum.DRAFT));

    //ONLY DRAFT & EDITABLE CAMPAIGNS
    setCampaignToolTableData(tableDataActiveCampaign.filter(campaign => !([CampaignStateEnum.ACTIVE, CampaignStateEnum.OUTDATED].includes(campaign[CampaignTableModel.State]))));


    //CALCULATE COUNT VALUES
    const totalCampaigns = campaignReponseData.length;
    setTotalNumberOfCampaigns(totalCampaigns);

    setTotalNumberOfRunning(campaignReponseData.filter((active) => active.state === "Running").length);
    setTotalNumberOfPaused(campaignReponseData.filter((active) => active.state === "Paused").length);
    setTotalNumberOfCanceled(campaignReponseData.filter((active) => active.state === "Canceled").length);
  };

  const renderActiveCampaignsTable = () => {
    return <CampaignTable data={campaignActiveTableData} />;
  };

  const renderCampaignToolTable = () => {
    return <CampaignTable data={campaignToolTableData} />;
  };

  const renderCampaignDetailToolTable = () => {
    return <CampaignTable data={campaignToolDetailTableDataArray} />;
  };

  const campaignToolDetailTableDataArray = CampaignToolDetails.map((campaigns) => {
    return {
      MSISDNS: campaigns.MSISDNS,
      ActivationDate: campaigns.ActivationDate,
      ProductID: campaigns.ProductID,
      MachineID: campaigns.MachineID,
      Amount: CurrencyUtil.formatAsCurrency(campaigns.Amount),
      CustomerStatus: campaigns.CustomerStatus,
    };
  });

  // --------------------------------------------------------
  // VOUCHERS API ENDPOINTS (CAMPAIGNS/VOUCHERS SERVER FETCH)
  // --------------------------------------------------------

  useEffect(() => {
    if(initialized && merchantId){
      getCampaignsEndpoint(merchantId)
    }
  }, [initialized, merchantId])

  const getCampaignsEndpoint = (merchantId) => {
    setLoadingFlag(true)
    //FETCH MERCHANTS
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.getCampaignsMethod}`;

    // FETCH BACKEND
    axiosInstance?.current
      ?.get(url)
      .then((res) => {
        setLoadingFlag(false)
        const responseData = res.data || [];
        //console.log("GET ACTIVE CAMPAIGNS DATA =>", responseData);
        setActiveCampaigns(responseData);

        //CALCULATE ALL
        calculateCampaignsData(responseData);
      })
      .catch((err) => {
        setLoadingFlag(false)
        console.log(err)
      });

  };

  //POST
  const postCampaignsEndpoint = async (newCampaign, heroImage, voucherImage) => {

    // ----------------------------------------------------------------
    // SET FETCH URL
    // ----------------------------------------------------------------
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.postCampaignsMethod}`;
    //FETCH BACKEND

    axiosInstance?.current
      ?.post(url, newCampaign)
      .then((res) => {
        console.log("POST CAMPAIGN RESPONSE => ", res)

        const CAMPAIGN_ID = res.data?.id

        //IMAGES WILL UPLOAD AND CALL GET CAMPAIGNS
        imageCampaignUpload(CAMPAIGN_ID, heroImage, ImageTypeMethodEnum.HERO)
        imageCampaignUpload(CAMPAIGN_ID, voucherImage, ImageTypeMethodEnum.VOUCHER)


        getCampaignsEndpoint(merchantId)

        //NAVIGATE TO CAMPAIGNS TOOL PAGE
        navigate(`${process.env.PUBLIC_URL}/${DASHBOARD_ROUTES.CAMPAIGNTOOLS_PAGE}`)

      })
      .catch((err) => console.log(err));
  };

  const postCampaignPublishChanges = (campaignId, method) => {
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.postCampaignsMethod}/${campaignId}/${method}`

    axiosInstance?.current
      ?.post(url)
      .then((res) => {
        const responseData = res.data || [];
        console.log("STATUS CHANGE CAMPAIGNS RESPONSE =>", responseData);

        //setActiveCampaigns(campaigns)

        //FETCH NEW CAMPAIGNS
        getCampaignsEndpoint(merchantId)

        //NAVIGATE TO ACTIVE CAMPAIGNS PAGE
        navigate(`${process.env.PUBLIC_URL}/${DASHBOARD_ROUTES.ACTIVECAMPAIGNS_PAGE}`)
      })
      .catch((err) => console.log(err));
  }

  //PUT
  const updateCampaignEndpoint = (changedCampaign, campaignId, heroImage, voucherImage) => {
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.postCampaignsMethod}/${campaignId}`

    console.log({ changedCampaign }, { campaignId })

    axiosInstance?.current
      ?.put(url, changedCampaign)
      .then((res) => {
        const responseData = res.data || [];
        console.log("UPDATE CAMPAIGNS RESPONSE =>", responseData);

        //IMAGES UPDATE & UPLOAD AND CALL GET CAMPAIGNS
        console.log("IMAGES => HERO => ", heroImage, ", VOUCHER => ", voucherImage)
        if (heroImage) imageCampaignUpload(campaignId, heroImage, ImageTypeMethodEnum.HERO)
        if (voucherImage) imageCampaignUpload(campaignId, voucherImage, ImageTypeMethodEnum.VOUCHER)
        getCampaignsEndpoint(merchantId)

        //NAVIGATE TO CAMPAIGNS TOOL PAGE
        navigate(`${process.env.PUBLIC_URL}/${DASHBOARD_ROUTES.CAMPAIGNTOOLS_PAGE}`)

      })
      .catch((err) => console.log(err));
  }

  //DELETE
  const deleteCampaignEndpoint = (campaignId) => {
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.postCampaignsMethod}/${campaignId}`

    axiosInstance?.current
      ?.delete(url)
      .then((res) => {
        const responseData = res.data || [];
        console.log("DELETE ACTIVE CAMPAIGNS RESPONSE =>", responseData);

        //setActiveCampaigns(campaigns)

        //FETCH NEW CAMPAIGNS
        getCampaignsEndpoint(merchantId)

        //NAVIGATE TO CAMPAIGNS TOOL PAGE
        navigate(`${process.env.PUBLIC_URL}/${DASHBOARD_ROUTES.CAMPAIGNTOOLS_PAGE}`)
      })
      .catch((err) => console.log(err));
  }


  //IMAGES
  const imageCampaignUpload = (campaignId, imageFile, imageMethod) => {
    const url = `${process.env.REACT_APP_MANAGEMENT_BACKEND_URL}${environment.getMerchantsMethod}/${merchantId}${environment.postCampaignsMethod}/${campaignId}/${imageMethod}`

    //PREPARE MULTIPART FORM DATA
    const formData = new FormData();
    //const formDataKey = imageMethod === ImageTypeMethodEnum.HERO ? "heroImage" : "voucherImage"
    //formData.append(formDataKey, imageFile) // eg.  formData.append('heroImage', imageFile) 
    formData.append("file", imageFile) // eg.  formData.append('heroImage', imageFile) 
    //console.log("IMAGE FILE => ", imageFile)
    console.log("MUTIFORM DATA ==> ", ...formData)

    const config = {
      /*headers: {
        'content-type': 'multipart/form-data',
        //'content-type': imageFile.type,
        //'content-length': `${imageFile.size}`, // 👈 Headers need to be a string
      },*/

      headers: {
        'content-type': 'multipart/form-data',
        Authorization: initialized ? `Bearer ${kcToken}` : undefined,
      },

      //body: { [formDataKey]: imageFile },
      body: { file: imageFile },
    }

    return axiosInstanceMultipart?.current
      ?.post(url, formData, config)
      .then((res) => {
        const responseData = res.data || [];
        console.log(`[${imageMethod}] : IMAGE POST RESPONSE => `, responseData);

        //FETCH NEW CAMPAIGNS
        getCampaignsEndpoint(merchantId)

        //DISPLAY SUCCESS NOTIFICATION
        if (imageMethod === ImageTypeMethodEnum.HERO) {
          console.log("CALLED NOTIFICATION", imageMethod)
          ShowSuccessHeroToastMessage(t)
        }
        if (imageMethod === ImageTypeMethodEnum.VOUCHER) {
          console.log("CALLED NOTIFICATION", imageMethod)
          ShowSuccessVoucherToastMessage(t)
        }

      })
      .catch((err) => {
        //DISPLAY ERROR NOTIFICATION
        if (imageMethod === ImageTypeMethodEnum.HERO) {
          console.log("CALLED NOTIFICATION", imageMethod)
          ShowFailedHeroToastMessage(t)
        }
        if (imageMethod === ImageTypeMethodEnum.VOUCHER) {
          console.log("CALLED NOTIFICATION", imageMethod)
          ShowFailedVoucherToastMessage(t)
        }
        console.log(err)
      });
  }
  // --------------------------------------------------------
  // --------------------------------------------------------

  return {
    CampaignTableData: renderActiveCampaignsTable(),
    CampaignToolTableData: renderCampaignToolTable(),
    CampaignDetailToolTableData: renderCampaignDetailToolTable(),

    activeCampaigns,
    campaignActiveTableData,
    campaignToolTableData,

    startDate,
    endDate,

    setActiveCampaigns,
    filteredActiveTable,
    calculateCampaignsData,

    //CAMPAIGNS ENDPOINTS
    postCampaignsEndpoint,
    deleteCampaignEndpoint,
    updateCampaignEndpoint,
    postCampaignPublishChanges,

    //IMAGE ENDPOINTS
    imageCampaignUpload,

    //Totals
    totalNumberOfCampaigns,
    totalNumberOfRunning,
    totalNumberOfPaused,
    totalNumberOfCanceled,

    loadingFlag,

    //MANAGEMENT BACKEND USER/MERCHANT info
    merchantInfo
  };
};
